// // frontend/src/pages/CandidateDashboard.jsx
// import React, { useEffect, useState, useRef, useCallback } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
// const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || "";

// function loadRazorpaySdk() {
//   return new Promise((resolve, reject) => {
//     if (window.Razorpay) return resolve(true);
//     const existing = document.querySelector(
//       'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
//     );
//     if (existing) {
//       existing.addEventListener("load", () => resolve(true));
//       existing.addEventListener("error", () =>
//         reject(new Error("Razorpay script failed to load"))
//       );
//       return;
//     }
//     const s = document.createElement("script");
//     s.src = "https://checkout.razorpay.com/v1/checkout.js";
//     s.async = true;
//     s.onload = () => resolve(true);
//     s.onerror = () => reject(new Error("Razorpay script failed to load"));
//     document.body.appendChild(s);
//   });
// }

// export default function CandidateDashboard() {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [student, setStudent] = useState(null);
//   const [fees, setFees] = useState({ courseFee: 0, entranceFee: 500 });
//   const [testInfo, setTestInfo] = useState(null);
//   const [acceptedTC, setAcceptedTC] = useState(false);

//   const [coupon, setCoupon] = useState("");
//   const [couponApplied, setCouponApplied] = useState(null);

//   const [paying, setPaying] = useState(false);
//   const [error, setError] = useState("");
//   const [refreshKey, setRefreshKey] = useState(0);
//   const tokenRef = useRef(localStorage.getItem("candidateToken") || "");

//   const pollRef = useRef(null);

//   const headersFor = useCallback(() => {
//     const t = tokenRef.current || localStorage.getItem("candidateToken") || "";
//     if (t) tokenRef.current = t;
//     return t ? { Authorization: `Bearer ${t}` } : {};
//   }, []);

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     if (params.get("goBatches") === "1") {
//       navigate("/candidate/batches", { replace: true });
//     }
//   }, [navigate]);

//   const loadHome = useCallback(
//     async ({ silent = false } = {}) => {
//       if (!silent) {
//         setLoading(true);
//       }
//       setError("");
//       const token = localStorage.getItem("candidateToken") || tokenRef.current;
//       if (!token) {
//         navigate("/candidate", { replace: true });
//         return;
//       }
//       tokenRef.current = token;
//       try {
//         const res = await axios.get(`${API}/api/candidate/home`, {
//           headers: headersFor(),
//           timeout: 15000,
//         });
//         setStudent(res.data.student || null);
//         if (res.data.fees) setFees(res.data.fees);
//         if (res.data.test) setTestInfo(res.data.test);
//       } catch (err) {
//         console.error("dashboard load error:", err);
//         if (err?.response?.status === 401) {
//           localStorage.removeItem("candidateToken");
//           tokenRef.current = "";
//           navigate("/candidate", { replace: true });
//           return;
//         }
//         const msg =
//           err?.response?.data?.message ||
//           err?.message ||
//           "Could not load dashboard. Check backend.";
//         setError(msg);
//       } finally {
//         if (!silent) setLoading(false);
//       }
//     },
//     [navigate, headersFor]
//   );

//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       if (!mounted) return;
//       await loadHome();
//     })();
//     return () => {
//       mounted = false;
//     };
//   }, [loadHome, refreshKey]);

//   useEffect(() => {
//     if (pollRef.current) {
//       clearInterval(pollRef.current);
//       pollRef.current = null;
//     }

//     if (!student) return;

//     const attemptsUsed = Number(student.test_attempts || 0);
//     const maxAttemptsPerPayment = 3;

//     if (attemptsUsed < maxAttemptsPerPayment) {
//       pollRef.current = setInterval(() => {
//         loadHome({ silent: true });
//       }, 5000);
//     }

//     return () => {
//       if (pollRef.current) {
//         clearInterval(pollRef.current);
//         pollRef.current = null;
//       }
//     };
//   }, [student, loadHome]);

//   const finalEntranceDue = (() => {
//     const base = Number(fees?.entranceFee || 500);
//     if (couponApplied?.finalAmount != null)
//       return Math.max(0, Number(couponApplied.finalAmount));
//     const disc = Number(couponApplied?.discount || 0);
//     return Math.max(0, base - disc);
//   })();

//   async function applyCoupon() {
//     setError("");
//     setCouponApplied(null);

//     if (!coupon || !coupon.trim()) {
//       setError("Enter coupon code");
//       return;
//     }
//     const headers = headersFor();
//     if (!headers.Authorization) {
//       navigate("/candidate", { replace: true });
//       return;
//     }

//     try {
//       const res = await axios.post(
//         `${API}/api/payment/create-order`,
//         {
//           amount: fees.entranceFee || 500,
//           couponCode: coupon.trim(),
//           preview: true,
//         },
//         { headers, timeout: 15000 }
//       );

//       if (res?.data?.couponApplied) {
//         setCouponApplied(res.data.couponApplied);
//       } else if (res?.data?.coupon) {
//         const c = res.data.coupon;
//         setCouponApplied({
//           code: c.code,
//           discount: c.discount ?? c.discount_pct ?? 0,
//           finalAmount:
//             c.discount != null
//               ? Math.max(
//                   0,
//                   Number(fees.entranceFee || 500) - Number(c.discount)
//                 )
//               : null,
//         });
//       } else if (res?.data?.preview && res?.data?.couponApplied === null) {
//         setCouponApplied(null);
//         setError("Coupon not applicable.");
//       } else {
//         setError(
//           "Could not validate coupon in preview; it will be validated at checkout."
//         );
//       }
//     } catch (err) {
//       console.error("applyCoupon error:", err);
//       const msg =
//         err?.response?.data?.message ||
//         err?.message ||
//         "Coupon validation failed.";
//       setError(msg);
//     }
//   }

//   async function handlePay() {
//     setError("");
//     if (!acceptedTC) {
//       setError("Please accept Terms & Conditions.");
//       return;
//     }
//     const headers = headersFor();
//     if (!headers.Authorization) {
//       navigate("/candidate", { replace: true });
//       return;
//     }

//     if (paying) return;
//     setPaying(true);

//     try {
//       await loadRazorpaySdk();

//       const keyIdFromEnv =
//         RAZORPAY_KEY_ID || process.env.REACT_APP_RAZORPAY_KEY_ID || "http://localhost:5000";
//       if (!keyIdFromEnv) {
//         throw new Error(
//           "Razorpay public key missing in frontend env (REACT_APP_RAZORPAY_KEY_ID). Add it to frontend/.env and restart."
//         );
//       }

//       const createBody = {
//         amount: finalEntranceDue || fees.entranceFee || 500,
//         type: "eligibility_test",
//         couponCode: couponApplied ? couponApplied.code : coupon || undefined,
//         courseId: fees?.courseId || fees?.course_id || student?.course_id || null,
//       };

//       const create = await axios.post(
//         `${API}/api/payment/create-order`,
//         createBody,
//         {
//           headers,
//           timeout: 20000,
//         }
//       );

//       if (!create?.data) {
//         throw new Error("Order creation failed: empty response from server");
//       }
//       if (create.data.message && create.data.error && !create.data.order) {
//         throw new Error(create.data.message || "Order creation failed");
//       }

//       const order = create.data.order || create.data;
//       if (!order || (!order.id && !create.data?.id)) {
//         const msg =
//           create.data?.message || "Order creation failed (no order returned)";
//         throw new Error(msg);
//       }

//       const rzpOptions = {
//         key: keyIdFromEnv || create.data?.key_id || "",
//         amount: order?.amount || create.data?.amount,
//         currency: order?.currency || create.data?.currency || "INR",
//         name: "Concerted Path",
//         description: "Scholarship Test Fee",
//         order_id: order?.id || create.data?.id,
//         handler: async (paymentResponse) => {
//           try {
//             const verifyBody = {
//               razorpay_order_id: paymentResponse.razorpay_order_id,
//               razorpay_payment_id: paymentResponse.razorpay_payment_id,
//               razorpay_signature: paymentResponse.razorpay_signature,
//               enrollmentId:
//                 create.data?.enrollmentId ||
//                 create.data?.enrollment_id ||
//                 null,
//             };
//             await axios.post(`${API}/api/payment/verify`, verifyBody, {
//               headers,
//               timeout: 20000,
//             });
//             alert(
//               "✅ Payment verified. Your scholarship test attempts have been unlocked."
//             );
//             setRefreshKey((k) => k + 1);
//           } catch (verifyErr) {
//             console.error("verify error:", verifyErr);
//             alert("Payment verification failed. Contact support with payment id.");
//           }
//         },
//         prefill: {
//           name: student?.name || "",
//           email: student?.email || "",
//         },
//         theme: { color: "#111" },
//       };

//       const rzp = new window.Razorpay(rzpOptions);
//       rzp.open();
//     } catch (err) {
//       console.error("handlePay error:", err);
//       const msg =
//         err?.response?.data?.message ||
//         err?.message ||
//         "Could not start payment.";
//       setError(msg);
//     } finally {
//       setPaying(false);
//     }
//   }

//   if (loading) {
//     return (
//       <div className="container my-5 text-center">
//         <div className="spinner-border text-warning" role="status" />
//         <div className="mt-3">Loading your dashboard...</div>
//       </div>
//     );
//   }

//   if (!student) {
//     return (
//       <div className="container my-5">
//         <div className="alert alert-warning">
//           Please login as candidate to view dashboard.
//         </div>
//         <button className="btn btn-primary" onClick={() => navigate("/candidate")}>
//           Go to login
//         </button>
//       </div>
//     );
//   }

//   const paidBase = String(student?.payment_status || "")
//     .toLowerCase()
//     .includes("paid");

//   const attemptsUsed = Number(student?.test_attempts || 0);
//   const maxAttemptsPerPayment = 3;

//   const canStartTest = paidBase && attemptsUsed < maxAttemptsPerPayment;

//   const shouldShowPaySection = !paidBase || (paidBase && !canStartTest);

//   const showEnrollButton =
//     Number(student?.test_attempts || 0) > 0 && !student?.enrolled;

//   return (
//     <div className="container my-5">
//       {error && <div className="alert alert-danger">{error}</div>}

//       <div className="p-3 bg-light rounded mb-4">
//         <div style={{ display: "flex", gap: 16 }}>
//           <div
//             style={{
//               width: 72,
//               height: 72,
//               background: "#1e90ff",
//               color: "#fff",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontWeight: "700",
//               borderRadius: 4,
//             }}
//           >
//             {student.name
//               ? student.name
//                   .split(" ")
//                   .map((n) => n[0])
//                   .slice(0, 2)
//                   .join("")
//               : "?"}
//           </div>
//           <div style={{ flex: 1 }}>
//             <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
//               <div>
//                 <h2 className="mb-0">{student.name}</h2>
//                 <div className="text-muted">{student.email}</div>
//                 <div className="text-muted mt-2">
//                   {student.payment_status || "unpaid"}
//                 </div>

//                 {showEnrollButton && (
//                   <div className="mt-3">
//                     <button
//                       className="btn btn-primary"
//                       onClick={() => navigate("/candidate/batches")}
//                     >
//                       Enroll in Batch
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="row g-4">
//         <div className="col-md-6">
//           <div className="card shadow-sm">
//             <div className="card-body">
//               <h4 className="mb-3">Candidate Overview</h4>
//               <p>
//                 <strong>Attempts Used:</strong> {attemptsUsed}
//               </p>
//               <p>
//                 <strong>Last Score:</strong>{" "}
//                 {student.test_score != null ? `${Number(student.test_score).toFixed(2)}%` : "0.00%"}
//               </p>
//               <p>
//                 <strong>Scholarship Tier:</strong>{" "}
//                 {student.scholarship_tier != null && student.scholarship_tier !== ""
//                   ? `${student.scholarship_tier}%`
//                   : "0%"}
//               </p>

//               <hr />
//               <h5>Fees & Discounts</h5>
//               <p>
//                 Course Fee:{" "}
//                 <b>₹{Number(fees.courseFee || 0).toLocaleString()}</b>
//               </p>
//               <p>
//                 Scholarship Test Fee:{" "}
//                 <b>₹{Number(fees.entranceFee || 500).toLocaleString()}</b>
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="col-md-6">
//           <div className="card shadow-sm">
//             <div className="card-body">
//               <h4 className="mb-3">Payment &amp; Start Test</h4>

//               {shouldShowPaySection ? (
//                 <>
//                   <p className="small text-muted">
//                     You can give <strong>3 attempts</strong> for each payment
//                     of the scholarship test fee.
//                     <br />
//                     Current attempts used: {attemptsUsed} / {maxAttemptsPerPayment}
//                   </p>

//                   <div className="form-check mb-3">
//                     <input
//                       className="form-check-input"
//                       type="checkbox"
//                       id="tc"
//                       checked={acceptedTC}
//                       onChange={(e) => setAcceptedTC(e.target.checked)}
//                     />
//                     <label className="form-check-label" htmlFor="tc">
//                       I accept the Terms &amp; Conditions
//                     </label>
//                   </div>

//                   <div className="mb-3">
//                     <label
//                       className="form-label fw-semibold"
//                       htmlFor="couponCode"
//                     >
//                       Have a coupon code?
//                     </label>
//                     <div className="d-flex gap-2">
//                       <input
//                         id="couponCode"
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter coupon"
//                         value={coupon}
//                         onChange={(e) =>
//                           setCoupon(e.target.value.toUpperCase())
//                         }
//                         style={{ maxWidth: "180px" }}
//                       />
//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary"
//                         onClick={applyCoupon}
//                       >
//                         Apply
//                       </button>
//                     </div>

//                     {couponApplied && (
//                       <small className="text-success d-block mt-1">
//                         Coupon <strong>{couponApplied.code}</strong> applied.
//                         New payable amount: ₹
//                         {Number(finalEntranceDue).toLocaleString()}
//                       </small>
//                     )}
//                   </div>

//                   <div className="mb-3">
//                     <div className="h5">
//                       Payable: ₹{Number(finalEntranceDue).toLocaleString()}
//                     </div>
//                     <button
//                       className="btn btn-success mt-2"
//                       disabled={!acceptedTC || paying}
//                       onClick={handlePay}
//                     >
//                       {paying
//                         ? "Processing…"
//                         : `Pay ₹${Number(
//                             finalEntranceDue
//                           ).toLocaleString()} & Unlock 3 Attempts`}
//                     </button>
//                   </div>
//                 </>
//               ) : (
//                 <div className="alert alert-success">
//                   ✅ Scholarship test fee paid — you can start the test.
//                 </div>
//               )}

//               <hr />
//               <h5>Take Entrance Test</h5>
//               {canStartTest ? (
//                 <>
//                   <p className="small text-muted mb-2">
//                     Attempts used in this payment cycle: {attemptsUsed} /{" "}
//                     {maxAttemptsPerPayment}
//                   </p>
//                   <button
//                       className="btn btn-primary"
//                       onClick={() => navigate("/candidate/test")}
//                   >
//                       Start Test
//                   </button>
//                 </>
//               ) : (
//                 <div className="text-muted small">
//                   {attemptsUsed >= maxAttemptsPerPayment ? (
//                     <>
//                       You have used all 3 attempts. Pay the scholarship test fee
//                       again to unlock more attempts.
//                     </>
//                   ) : (
//                     <>Pay the scholarship test fee to unlock the test.</>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


// frontend/src/pages/CandidateDashboard.jsx
import React, { useEffect, useState, useRef, useCallback } from "react";
import api from "../utils/api";
import { useNavigate } from "react-router-dom";

const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || "";

function loadRazorpaySdk() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const existing = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () =>
        reject(new Error("Razorpay script failed to load"))
      );
      return;
    }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Razorpay script failed to load"));
    document.body.appendChild(s);
  });
}

export default function CandidateDashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [student, setStudent] = useState(null);
  const [fees, setFees] = useState({ courseFee: 0, entranceFee: 500 });
  const [testInfo, setTestInfo] = useState(null);
  const [acceptedTC, setAcceptedTC] = useState(false);

  const [coupon, setCoupon] = useState("");
  const [couponApplied, setCouponApplied] = useState(null);

  const [paying, setPaying] = useState(false);
  const [error, setError] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const tokenRef = useRef(localStorage.getItem("candidateToken") || "");

  const pollRef = useRef(null);

  const headersFor = useCallback(() => {
    const t = tokenRef.current || localStorage.getItem("candidateToken") || "";
    if (t) tokenRef.current = t;
    return t ? { Authorization: `Bearer ${t}` } : {};
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("goBatches") === "1") {
      navigate("/candidate/batches", { replace: true });
    }
  }, [navigate]);

  const loadHome = useCallback(
    async ({ silent = false } = {}) => {
      if (!silent) {
        setLoading(true);
      }
      setError("");
      const token = localStorage.getItem("candidateToken") || tokenRef.current;
      if (!token) {
        navigate("/candidate", { replace: true });
        return;
      }
      tokenRef.current = token;
      try {
        const res = await api.get("/api/candidate/home");
        setStudent(res.data.student || null);
        if (res.data.fees) setFees(res.data.fees);
        if (res.data.test) setTestInfo(res.data.test);
      } catch (err) {
        console.error("dashboard load error:", err);
        if (err?.response?.status === 401) {
          localStorage.removeItem("candidateToken");
          tokenRef.current = "";
          navigate("/candidate", { replace: true });
          return;
        }
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "Could not load dashboard. Check backend.";
        setError(msg);
      } finally {
        if (!silent) setLoading(false);
      }
    },
    [navigate, headersFor]
  );

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!mounted) return;
      await loadHome();
    })();
    return () => {
      mounted = false;
    };
  }, [loadHome, refreshKey]);

  useEffect(() => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }

    if (!student) return;

    const attemptsUsed = Number(student.test_attempts || 0);
    const maxAttemptsPerPayment = 3;

    if (attemptsUsed < maxAttemptsPerPayment) {
      pollRef.current = setInterval(() => {
        loadHome({ silent: true });
      }, 5000);
    }

    return () => {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };
  }, [student, loadHome]);

  const finalEntranceDue = (() => {
    const base = Number(fees?.entranceFee || 500);
    if (couponApplied?.finalAmount != null)
      return Math.max(0, Number(couponApplied.finalAmount));
    const disc = Number(couponApplied?.discount || 0);
    return Math.max(0, base - disc);
  })();

  async function applyCoupon() {
    setError("");
    setCouponApplied(null);

    if (!coupon || !coupon.trim()) {
      setError("Enter coupon code");
      return;
    }
    const headers = headersFor();
    if (!headers.Authorization) {
      navigate("/candidate", { replace: true });
      return;
    }

    try {
      const res = await api.post("/api/payment/create-order", {
        amount: fees.entranceFee || 500,
        couponCode: coupon.trim(),
        preview: true,
      });

      if (res?.data?.couponApplied) {
        setCouponApplied(res.data.couponApplied);
      } else if (res?.data?.coupon) {
        const c = res.data.coupon;
        setCouponApplied({
          code: c.code,
          discount: c.discount ?? c.discount_pct ?? 0,
          finalAmount:
            c.discount != null
              ? Math.max(
                  0,
                  Number(fees.entranceFee || 500) - Number(c.discount)
                )
              : null,
        });
      } else if (res?.data?.preview && res?.data?.couponApplied === null) {
        setCouponApplied(null);
        setError("Coupon not applicable.");
      } else {
        setError(
          "Could not validate coupon in preview; it will be validated at checkout."
        );
      }
    } catch (err) {
      console.error("applyCoupon error:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Coupon validation failed.";
      setError(msg);
    }
  }

  async function handlePay() {
    setError("");
    if (!acceptedTC) {
      setError("Please accept Terms & Conditions.");
      return;
    }
    const headers = headersFor();
    if (!headers.Authorization) {
      navigate("/candidate", { replace: true });
      return;
    }

    if (paying) return;
    setPaying(true);

    try {
      await loadRazorpaySdk();

      const keyIdFromEnv =
            RAZORPAY_KEY_ID || process.env.REACT_APP_RAZORPAY_KEY_ID;
      if (!keyIdFromEnv) {
        throw new Error(
          "Razorpay public key missing in frontend env (REACT_APP_RAZORPAY_KEY_ID). Add it to frontend/.env and restart."
        );
      }

      const createBody = {
        amount: finalEntranceDue || fees.entranceFee || 500,
        type: "eligibility_test",
        couponCode: couponApplied ? couponApplied.code : coupon || undefined,
        courseId: fees?.courseId || fees?.course_id || student?.course_id || null,
      };

      const create = await api.post("/api/payment/create-order", createBody);

      if (!create?.data) {
        throw new Error("Order creation failed: empty response from server");
      }
      if (create.data.message && create.data.error && !create.data.order) {
        throw new Error(create.data.message || "Order creation failed");
      }

      const order = create.data.order || create.data;
      if (!order || (!order.id && !create.data?.id)) {
        const msg =
          create.data?.message || "Order creation failed (no order returned)";
        throw new Error(msg);
      }

      const rzpOptions = {
        key: keyIdFromEnv || create.data?.key_id || "",
        amount: order?.amount || create.data?.amount,
        currency: order?.currency || create.data?.currency || "INR",
        name: "Concerted Path",
        description: "Scholarship Test Fee",
        order_id: order?.id || create.data?.id,
        handler: async (paymentResponse) => {
          try {
            const verifyBody = {
              razorpay_order_id: paymentResponse.razorpay_order_id,
              razorpay_payment_id: paymentResponse.razorpay_payment_id,
              razorpay_signature: paymentResponse.razorpay_signature,
              enrollmentId:
                create.data?.enrollmentId ||
                create.data?.enrollment_id ||
                null,
            };
            await api.post("/api/payment/verify", verifyBody);
            alert(
              "✅ Payment verified. Your scholarship test attempts have been unlocked."
            );
            setRefreshKey((k) => k + 1);
          } catch (verifyErr) {
            console.error("verify error:", verifyErr);
            alert("Payment verification failed. Contact support with payment id.");
          }
        },
        prefill: {
          name: student?.name || "",
          email: student?.email || "",
        },
        theme: { color: "#111" },
      };

      const rzp = new window.Razorpay(rzpOptions);
      rzp.open();
    } catch (err) {
      console.error("handlePay error:", err);
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Could not start payment.";
      setError(msg);
    } finally {
      setPaying(false);
    }
  }

  if (loading) {
    return (
      <div className="container my-5 text-center">
        <div className="spinner-border text-warning" role="status" />
        <div className="mt-3">Loading your dashboard...</div>
      </div>
    );
  }

  if (!student) {
    return (
      <div className="container my-5">
        <div className="alert alert-warning">
          Please login as candidate to view dashboard.
        </div>
        <button className="btn btn-primary" onClick={() => navigate("/candidate")}>
          Go to login
        </button>
      </div>
    );
  }

  const paidBase = String(student?.payment_status || "")
    .toLowerCase()
    .includes("paid");

  const attemptsUsed = Number(student?.test_attempts || 0);
  const maxAttemptsPerPayment = 3;

  const canStartTest = paidBase && attemptsUsed < maxAttemptsPerPayment;

  const shouldShowPaySection = !paidBase || (paidBase && !canStartTest);

  const showEnrollButton =
    Number(student?.test_attempts || 0) > 0 && !student?.enrolled;

  return (
    <div className="container my-5">
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="p-3 bg-light rounded mb-4">
        <div style={{ display: "flex", gap: 16 }}>
          <div
            style={{
              width: 72,
              height: 72,
              background: "#1e90ff",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "700",
              borderRadius: 4,
            }}
          >
            {student.name
              ? student.name
                  .split(" ")
                  .map((n) => n[0])
                  .slice(0, 2)
                  .join("")
              : "?"}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <div>
                <h2 className="mb-0">{student.name}</h2>
                <div className="text-muted">{student.email}</div>
                <div className="text-muted mt-2">
                  {student.payment_status || "unpaid"}
                </div>

                {showEnrollButton && (
                  <div className="mt-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate("/candidate/batches")}
                    >
                      Enroll in Batch
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h4 className="mb-3">Candidate Overview</h4>
              <p>
                <strong>Attempts Used:</strong> {attemptsUsed}
              </p>
              <p>
                <strong>Last Score:</strong>{" "}
                {student.test_score != null ? `${Number(student.test_score).toFixed(2)}%` : "0.00%"}
              </p>
              <p>
                <strong>Scholarship Tier:</strong>{" "}
                {student.scholarship_tier != null && student.scholarship_tier !== ""
                  ? `${student.scholarship_tier}%`
                  : "0%"}
              </p>

              <hr />
              <h5>Fees & Discounts</h5>
              <p>
                Course Fee:{" "}
                <b>₹{Number(fees.courseFee || 0).toLocaleString()}</b>
              </p>
              <p>
                Scholarship Test Fee:{" "}
                <b>₹{Number(fees.entranceFee || 500).toLocaleString()}</b>
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h4 className="mb-3">Payment &amp; Start Test</h4>

              {shouldShowPaySection ? (
                <>
                  <p className="small text-muted">
                    You can give <strong>3 attempts</strong> for each payment
                    of the scholarship test fee.
                    <br />
                    Current attempts used: {attemptsUsed} / {maxAttemptsPerPayment}
                  </p>

                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="tc"
                      checked={acceptedTC}
                      onChange={(e) => setAcceptedTC(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="tc">
                      I accept the Terms &amp; Conditions
                    </label>
                  </div>

                  <div className="mb-3">
                    <label
                      className="form-label fw-semibold"
                      htmlFor="couponCode"
                    >
                      Have a coupon code?
                    </label>
                    <div className="d-flex gap-2">
                      <input
                        id="couponCode"
                        type="text"
                        className="form-control"
                        placeholder="Enter coupon"
                        value={coupon}
                        onChange={(e) =>
                          setCoupon(e.target.value.toUpperCase())
                        }
                        style={{ maxWidth: "180px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={applyCoupon}
                      >
                        Apply
                      </button>
                    </div>

                    {couponApplied && (
                      <small className="text-success d-block mt-1">
                        Coupon <strong>{couponApplied.code}</strong> applied.
                        New payable amount: ₹
                        {Number(finalEntranceDue).toLocaleString()}
                      </small>
                    )}
                  </div>

                  <div className="mb-3">
                    <div className="h5">
                      Payable: ₹{Number(finalEntranceDue).toLocaleString()}
                    </div>
                    <button
                      className="btn btn-success mt-2"
                      disabled={!acceptedTC || paying}
                      onClick={handlePay}
                    >
                      {paying
                        ? "Processing…"
                        : `Pay ₹${Number(
                            finalEntranceDue
                          ).toLocaleString()} & Unlock 3 Attempts`}
                    </button>
                  </div>
                </>
              ) : (
                <div className="alert alert-success">
                  ✅ Scholarship test fee paid — you can start the test.
                </div>
              )}

              <hr />
              <h5>Take Entrance Test</h5>
              {canStartTest ? (
                <>
                  <p className="small text-muted mb-2">
                    Attempts used in this payment cycle: {attemptsUsed} /{" "}
                    {maxAttemptsPerPayment}
                  </p>
                  <button
                      className="btn btn-primary"
                      onClick={() => navigate("/candidate/test")}
                  >
                      Start Test
                  </button>
                </>
              ) : (
                <div className="text-muted small">
                  {attemptsUsed >= maxAttemptsPerPayment ? (
                    <>
                      You have used all 3 attempts. Pay the scholarship test fee
                      again to unlock more attempts.
                    </>
                  ) : (
                    <>Pay the scholarship test fee to unlock the test.</>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

